<template>
  <v-container>
    <MessagePopup :text="errorMessage" color="error"/>
    <div class='text-center mt-8' v-if="loading">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <div v-else>
      <h1>Details of article {{ item.sku }} from {{ item.supplier.name }}</h1>
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" md="2">
            <v-img
              class="mx-auto"
              max-height="200px"
              max-width="200px"
              contain
              :src="item.picture"
            ></v-img>
            <v-switch v-model="item.autocheck" label="Autocheck" @change="updateItem(item['@id'], { autocheck: item.autocheck })"></v-switch>
          </v-col>
          <v-col cols="12" sm="8" md="4">
            <h3>Product details</h3>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr><td>SKU</td><td>{{ item.sku }}</td></tr>
                  <tr><td>Manufacturer</td><td>{{ item.manufacturerName }}</td></tr>
                  <tr><td>Part Number</td><td>{{ item.manufacturerPartNumber }}</td></tr>
                  <tr><td>Description</td><td>{{ item.description }}</td></tr>
                  <tr><td>Packaging</td><td>{{ item.packaging }}</td></tr>
                  <tr><td>Product page</td><td><v-btn x-small outlined :href="item.link" target="_blank">open</v-btn></td></tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <SingleUpdateView
              :target="item['@id']"
            />
          </v-col>
        </v-row>
      </v-container>
      <ChartUpdatesPrices :updates="updates"/>
      <ChartUpdatesStock :updates="updates"/>
    </div>
  </v-container>
</template>

<script>
import MessagePopup from '@/components/MessagePopup.vue'
import SingleUpdateView from '@/components/SingleUpdateView.vue'
import ChartUpdatesPrices from '@/components/ChartUpdatesPrices'
import ChartUpdatesStock from '@/components/ChartUpdatesStock'

export default {
  data: () => ({
    item: null,
    updates: [],
    totalUpdates: 0,
    loading: true,
    errorMessage: ''
  }),
  components: {
    MessagePopup,
    SingleUpdateView,
    ChartUpdatesPrices,
    ChartUpdatesStock
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'ArticlesDetail') {
        this.loadArticleUpdates()
      }
    }
  },
  methods: {
    loadArticleUpdates () {
      this.loading = true
      this.$http(this.$directory + `/articles/${this.$route.params.id}`)
        .then(response => {
          this.item = response.data
          return response.data
        })
        .then(article => {
          return this.$http(
            this.item['@id'] + '/updates',
            {
              params: {
                page: 1,
                itemsPerPage: 100,
                pagination: true,
                order: {
                  createdAt: 'DESC'
                }
              }
            }
          )
        })
        .then(response => {
          this.updates = response.data['hydra:member']
          this.totalUpdates = response.data['hydra:totalItems']
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateItem (target, data) {
      this.errorMessage = ''
      this.$http.patch(target,
        data,
        {
          headers: {
            'Content-type': 'application/merge-patch+json'
          }
        }
      )
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
    }
  },
  created () {
    this.loadArticleUpdates()
  }
}
</script>
